export default {
    IVS_CHANNEL: 'ivs',
    MUX_CHANNEL: 'mux',
};
